import React from 'react';
import './App.scss';

import Designer from "./Designer";
import RandomFarmers from "./RandomFarmers";

function App() {
    return (
        <div className="App">
            <Designer/>
            <RandomFarmers/>
        </div>
    );
}

export default App;
